export const newLightBG = '#F1F6FF'
export const newDarkBG = '#0D0D2B'


export const newLightBGLight = '#FFFFFF'
export const newDarkBGLight = '#15153D'
